<script setup>
import "@/styles/css/glossary.scss";
import { onMounted } from "vue";
onMounted(() => {
  (function ($) {
    $(document).ready(function () {
      showScrolledHeader();

      $("a.glossary_category").on("click", function (event) {
        $("a.glossary_category").removeClass("active");
        $(this).addClass("active");

        if (this.hash !== "") {
          if (this.hash == "#") {
            this.hash = "num";
          }
          event.preventDefault();
          var hash = this.hash;
          window.location.hash = hash;
          var scrollLocation =
            $(hash).offset().top - ($("header.navigation").height() + 60);
          $(window).scrollTop(scrollLocation);
          $("select#categories").val(hash);
        }
      });

      $("select#categories").on("change", function (event) {
        var hash = $(this).val();

        if (hash !== "") {
          if (hash == "#") {
            hash = "num";
          }
          window.location.hash = hash;
          var scrollLocation =
            $(hash).offset().top - ($("header.navigation").height() + 60);
          $(window).scrollTop(scrollLocation);
        }
      });
    });

    $(window).on("scroll", function () {
      showScrolledHeader();
    });

    function showScrolledHeader() {
      if (
        jQuery(window).scrollTop() >=
        jQuery(".glossary-banner").offset().top +
          jQuery(".glossary-banner").height()
      ) {
        $(".scrolledGlossaryHeader").removeClass("hide");
      } else {
        $(".scrolledGlossaryHeader").addClass("hide");
      }
    }
  })(jQuery);
});
</script>
<template>
  <div class="page-container">
    <section class="glossary-banner glossary-posts banner-inner">
      <div class="container">
        <div class="glossary-intro">
          <h1
            class="wow fadeInDown animated"
            data-wow-duration="1s"
            style="visibility: visible; animation-duration: 1s"
          >
            Stock Market Glossary
          </h1>

          <h2
            class="wow fadeInUp animated"
            data-wow-duration="1s"
            style="visibility: visible; animation-duration: 1s"
          >
            Definitions of terms used in share trading and technical analysis
            for traders
          </h2>

          <div class="glossary-container">
            <ul class="glossary-terms">
              <li class="">
                <a href="/glossary/#num" class="glossary_category"> # </a>
              </li>
              <li class="">
                <a href="/glossary/#A" class="glossary_category"> A </a>
              </li>
              <li class="">
                <a href="/glossary/#B" class="glossary_category"> B </a>
              </li>
              <li class="">
                <a href="/glossary/#C" class="glossary_category"> C </a>
              </li>
              <li class="">
                <a href="/glossary/#D" class="glossary_category"> D </a>
              </li>
              <li class="">
                <a href="/glossary/#E" class="glossary_category"> E </a>
              </li>
              <li class="">
                <a href="/glossary/#F" class="glossary_category"> F </a>
              </li>
              <li class="">
                <a href="/glossary/#G" class="glossary_category"> G </a>
              </li>
              <li class="">
                <a href="/glossary/#H" class="glossary_category"> H </a>
              </li>
              <li class="">
                <a href="/glossary/#I" class="glossary_category"> I </a>
              </li>
              <li class="">
                <a href="/glossary/#J" class="glossary_category"> J </a>
              </li>
              <li class="">
                <a href="/glossary/#L" class="glossary_category"> L </a>
              </li>
              <li class="">
                <a href="/glossary/#M" class="glossary_category"> M </a>
              </li>
              <li class="">
                <a href="/glossary/#N" class="glossary_category"> N </a>
              </li>
              <li class="">
                <a href="/glossary/#O" class="glossary_category"> O </a>
              </li>
              <li class="">
                <a href="/glossary/#S" class="glossary_category"> S </a>
              </li>
              <li class="">
                <a href="/glossary/#T" class="glossary_category"> T </a>
              </li>
              <li class="">
                <a href="/glossary/#W" class="glossary_category"> W </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="scrolledGlossaryHeader hide">
      <div class="glossary-container hidden-xs">
        <ul class="glossary-terms">
          <li class="">
            <a href="/glossary/#num" class="glossary_category active"> # </a>
          </li>
          <li class="">
            <a href="/glossary/#A" class="glossary_category"> A </a>
          </li>
          <li class="">
            <a href="/glossary/#B" class="glossary_category"> B </a>
          </li>
          <li class="">
            <a href="/glossary/#C" class="glossary_category"> C </a>
          </li>
          <li class="">
            <a href="/glossary/#D" class="glossary_category"> D </a>
          </li>
          <li class="">
            <a href="/glossary/#E" class="glossary_category"> E </a>
          </li>
          <li class="">
            <a href="/glossary/#F" class="glossary_category"> F </a>
          </li>
          <li class="">
            <a href="/glossary/#G" class="glossary_category"> G </a>
          </li>
          <li class="">
            <a href="/glossary/#H" class="glossary_category"> H </a>
          </li>
          <li class="">
            <a href="/glossary/#I" class="glossary_category"> I </a>
          </li>
          <li class="">
            <a href="/glossary/#J" class="glossary_category"> J </a>
          </li>
          <li class="">
            <a href="/glossary/#L" class="glossary_category"> L </a>
          </li>
          <li class="">
            <a href="/glossary/#M" class="glossary_category"> M </a>
          </li>
          <li class="">
            <a href="/glossary/#N" class="glossary_category"> N </a>
          </li>
          <li class="">
            <a href="/glossary/#O" class="glossary_category"> O </a>
          </li>
          <li class="">
            <a href="/glossary/#S" class="glossary_category"> S </a>
          </li>
          <li class="">
            <a href="/glossary/#T" class="glossary_category"> T </a>
          </li>
          <li class="">
            <a href="/glossary/#W" class="glossary_category"> W </a>
          </li>
        </ul>
      </div>
      <div class="container mobile-cat-dropdown visible-xs hidden-md hidden-lg">
        <select name="event-dropdown" id="categories">
          <option value="#num" class="glossary_category">#</option>
          <option value="#A" class="glossary_category">A</option>
          <option value="#B" class="glossary_category">B</option>
          <option value="#C" class="glossary_category">C</option>
          <option value="#D" class="glossary_category">D</option>
          <option value="#E" class="glossary_category">E</option>
          <option value="#F" class="glossary_category">F</option>
          <option value="#G" class="glossary_category">G</option>
          <option value="#H" class="glossary_category">H</option>
          <option value="#I" class="glossary_category">I</option>
          <option value="#J" class="glossary_category">J</option>
          <option value="#L" class="glossary_category">L</option>
          <option value="#M" class="glossary_category">M</option>
          <option value="#N" class="glossary_category">N</option>
          <option value="#O" class="glossary_category">O</option>
          <option value="#S" class="glossary_category">S</option>
          <option value="#T" class="glossary_category">T</option>
          <option value="#W" class="glossary_category">W</option>
        </select>
      </div>
    </section>

    <section>
      <div class="">
        <div class="glossary-container">
          <div class="glossary-breadcrumbs_wrap">
            <ol
              itemscope=""
              itemtype="http://schema.org/BreadcrumbList"
              class="glossary-breadcrumbs"
            >
              <li
                itemprop="itemListElement"
                itemscope=""
                itemtype="http://schema.org/ListItem"
              >
                <a itemprop="item" href="/" title="Home">
                  <span itemprop="name">Home &gt;&nbsp;</span>
                </a>
                <meta itemprop="position" content="1" />
              </li>
              <li
                itemprop="itemListElement"
                itemscope=""
                itemtype="http://schema.org/ListItem"
              >
                <a itemprop="item" href="/glossary/" title="Glossary">
                  <span itemprop="name">Glossary&nbsp;</span>
                </a>
                <meta itemprop="position" content="2" />
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="glossary-posts">
      <div class="glossary-container">
        <div class="">
          <div class="post-info" id="num">
            <a
              
              class="post-link"
              ><h4>
                52 week high
                <p>
                  52 Week High is the highest price at which a particular stock
                  has traded in the last one year. Traders and investors look at
                  this price to help understand the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                52 week low
                <p>
                  52 Week Low is the lowest price at which a particular stock
                  has traded in the last one year. Traders and investors look at
                  this price to help understand the...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="A">
            <a
              
              class="post-link"
              ><h4>
                ABC Wave Theory
                <p>
                  Elliott Wave Theory, or ABC wave theory, is a term for
                  three-wave counter trend price movement. Here, wave A is the
                  first price wave that is against the trend of...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Abridged Prospectus
                <p>
                  An Abridged Prospectus is a memorandum provided in Section
                  2(1) of the Companies Act, 2013. It includes all the
                  significant features of a prospectus, specified by the
                  Securities and Exchange...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Acceptance Credit
                <p>
                  An Acceptance Credit is a documentary credit that needs
                  provision of a term for the bill of exchange. Usually, the
                  bill is then accepted by the bank on which it...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Accrued Expenses
                <p>
                  Accrued expenses are those expenses which are listed on the
                  income statement but are unpaid. Accrued expenses are the
                  liabilities that the company needs to resolve at some future
                  date....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Accrued Interest
                <p>
                  The accrued interest is the interest earned on a bond or loan
                  that has not yet been paid to the lender by the borrower.
                  Points to remember: The accrued interest...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Accumulation Distribution Line (ADL)
                <p>
                  "The Accumulation Distribution Indicator Line (ADL) is an
                  indicator that looks at supply and demand by deducing whether
                  investors are generally buying (accumulating), or selling
                  (distributing) a certain stock. This...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Acid Test Ratio
                <p>
                  The ratio of a company’s current assets to its current
                  liabilities is known as the acid test ratio. It is a measure
                  of the company’s ability to stay liquid during...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Adaptive Filter
                <p>
                  Trying to predict future prices of an item, based on a dynamic
                  weighting of the item’s prices in the past, is referred to as
                  an adaptive filter. Points to remember...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Add on Method
                <p>
                  The Add on Method is an alternative method of paying interest
                  after it is added onto the principal at maturity. In this
                  method, the interest on the loan is calculated...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Add on offering
                <p>
                  An add-on offering refers to the additional shares made
                  available to the public by a publicly trading company. This is
                  usually done to raise capital for already existing operations,
                  expansion...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Adjusted Futures Price
                <p>
                  The adjusted futures price refers to the cash-equivalent of a
                  futures contract&nbsp;that will be used to purchase an asset
                  later on. Points to remember: The adjusted futures price takes
                  into...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Advance Decline Line
                <p>
                  The Advance-Decline Line (AD Line) is a marker based on Net
                  Advances, specified by the number of rising stocks minus the
                  number of declining stocks. The Advance Decline Line
                  measures...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Advance Payment Guarantee/Bond
                <p>
                  This is an agreement between two parties, stating advance
                  payments will be returned if the entity receiving these
                  payments, does not deliver on its end of the agreement. This
                  pertains...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Adverse Excursion
                <p>
                  An Adverse Excursion refers to a trade going in a direction
                  opposite to the one desired by the trader, after she/he has
                  executed it. For example, a drop after buying,...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                After-Hours Trading
                <p>
                  After-hours trading is the timeframe after the market closes
                  when a financial specialist can purchase and offer securities
                  outside of traditional exchange hours. Pre-market trading,
                  conversely, happens in the hours...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Algorithmic trading
                <p>
                  Algorithmic Trading is the process where a pre-programmed
                  trading instruction is fed into the computer program in order
                  to execute an automated trade. Specific instructions can be
                  assigned for variables...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                All or None Order
                <p>
                  It can be defined as a buy or a sell order that needs to be
                  executed completely or not at all. Partial execution of an
                  order is not possible. Either...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Alpha Figure
                <p>
                  The measure of an asset’s performance, relative to a benchmark
                  or market index is known as Alpha Figure. Points to Remember:
                  It takes into account the active returns on an...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Anaume Pattern
                <p>
                  In the trading analysis, an Anaume Pattern is a depletion
                  design (signifying "gap filling") made out of five candles on
                  the chart. It happens when the hole is filled in...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Anchoring and Adjustment
                <p>
                  A person starts with a first estimation (anchor) and then
                  makes incremental adjustments in view of extra data. These
                  adjustments are typically inadequate, giving the underlying
                  anchor a lot of...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual Earnings Change
                <p>
                  The change in earnings for a company, between the most recent
                  fiscal year and the preceding one is called the annual
                  earnings change. Points to remember: This change is due...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual Fund Operating Expenses
                <p>
                  In any given year, the expenses incurred to manage the funds
                  by an Asset Management Company are called Annual Fund
                  Operating Expenses. Points to Remember: The Asset Fund
                  Operating Expenses...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual General Meeting
                <p>
                  The AGM is a compulsory annual gathering of a company’s
                  shareholders in order to report and present that year’s
                  important events, discuss the company’s strategies and plans
                  for the upcoming...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual Net Profit Margin
                <p>
                  The amount of profit made by the company from their net sales,
                  expressed as a percentage is known as Annual Net Profit
                  Margin. It is calculated over one fiscal year....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual report
                <p>
                  An annual report of a company is an exhaustive report of a
                  company's activities that took place during the previous year.
                  Usually, shareholders look at annual reports in order to...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Annual Sales Change
                <p>
                  The change in sales between the recent fiscal year and the
                  preceding year, expressed as a percentage, is known as the
                  Annual Sales Change metric. Points to remember: The sales...
                </p>
              </h4></a
            ><a 
              ><h4>
                Arbitrage
                <p>
                  It is the buying and selling of securities in different
                  markets at the same time so as to make a profit by taking an
                  advantage of differing prices of the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Arbitrage Selling
                <p>
                  When a person buys security from one market at a certain
                  price, and sells it in another market at a higher price, the
                  process is known as Arbitrage Selling. Points...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Ask or Offer
                <p>
                  It is the act of putting up securities for sale (or offering)
                  by a seller. It is accompanied by an Ask Price. Points to
                  remember: The basis of the stock...
                </p>
              </h4></a
            ><a 
              ><h4>
                Ask Price
                <p>
                  The lowest price at which the seller is willing to sell the
                  security is known as ask price. Also commonly known as buying
                  price. Points to remember: The asking price...
                </p>
              </h4></a
            ><a 
              ><h4>
                Ask Size
                <p>
                  The amount of the security that is available at the Asking
                  Price is known as the Ask Size. In other words, the number of
                  securities being put up for sale...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Asset Allocation
                <p>
                  When funds are diversified based on risk assessment the
                  process is termed as ‘Asset Allocation.’ The assets can be
                  diversified into different categories like real estate,
                  stocks, bonds, various sectors...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Asset Allocation Fund
                <p>
                  A fund that invests over a range of assets - such as stocks,
                  bonds and others is called an Asset Allocation Fund. This is
                  unlike a regular mutual fund, which...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Asset Management Company (AMC)
                <p>
                  Registered with SEBI, an Asset Management Company is one that
                  handles all the assets within the mutual funds it manages,
                  accepts investments from its customers and takes related
                  decisions on...
                </p>
              </h4></a
            ><a 
              ><h4>
                Assets
                <p>
                  Everything from money to securities to real estate that is
                  owned by the company and adds to its bottom line, is known as
                  assets. An asset could be tangible and...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                At the Close or Closing Price
                <p>
                  The price of the last traded stock at the end of the day is
                  known as ‘At the Close.' Points to remember: It is important
                  as it provides information about...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                At the Money
                <p>
                  When the strike price of the option is identical to the price
                  of the stock, the situation is termed as ‘at the money.’ An
                  option placed in an ‘at the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                At the Open
                <p>
                  An ‘at the open’ is a directive of selling or buying
                  securities at the very beginning of the day when trading
                  opens. Points to remember: If the open orders are...
                </p>
              </h4></a
            ><a 
              ><h4>
                Auction
                <p>
                  A marketplace instrument where potential buyers bid on a
                  particular product, assets and/or services. The person who
                  places the highest bid purchases the item on auction.
                  Historically, auctions were a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Authorized Capital
                <p>
                  An authorized capital or an authorized share capital is the
                  maximum equity capital that a company is authorized to issue
                  in order to allocate them to shareholders. Points to
                  remember:...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Automatic Investment Plan
                <p>
                  When a small amount of money is directly deducted from your
                  (investor’s) bank account and invested in a mutual fund of
                  your choice, the entire process is called an Automatic...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Automatic Reinvestment
                <p>
                  Automatic reinvestment is an investment option in which the
                  money earned from a fund’s dividends or capital gains is used
                  again automatically to buy more units in the funds. Points...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Autoregressive
                <p>
                  Autoregression is the use of previous data in order to predict
                  the future data. The prediction is done by taking the weighted
                  sum of the previous values. Points to remember:...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Average Daily Volume
                <p>
                  The average number of securities traded per day over a
                  specific period of time is known as the average daily volume.
                  The average trading volume can increase or decrease
                  according...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Average P/E Ratio
                <p>
                  P/E stands for price/earnings. The average P/E ratio is the
                  current price (market price) of a share divided by the earning
                  per share. The P/E ratio is expressed as a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Average True Range (ATR)
                <p>
                  Average True Range (ATR) is a useful indicator and can be
                  applied to stocks and indices. It is the measure of volatility
                  of a price range. The ATR is a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Averaging Down
                <p>
                  When an investor buys more securities at a lower price than
                  the initial investment, the move is called averaging down. It
                  is done in order to reduce the average cost...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="B">
            <a
              
              class="post-link"
              ><h4>
                Back End Load
                <p>
                  When an investor exits or sells a mutual fund, they need to
                  pay a certain amount of commission or fee which is called as
                  Back End Load. This is also...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Back Months
                <p>
                  Back months refer to the available futures contracts for a
                  commodity that has expiration farthest into the future. Points
                  to remember: The liquidity of a back month futures contract
                  constantly...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Backtesting
                <p>
                  Backtesting is a technique to test the trading strategy on
                  historical data which is relevant in order to ensure its
                  viability. It is also known as “interpreting the past.” If...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Balance Sheet
                <p>
                  Balance sheet is a financial statement that represents the
                  company’s assets and liabilities as of a specific date. The
                  difference between these two is termed as a company’s net
                  worth....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Balanced fund
                <p>
                  Balanced Funds are usually set up for those investors who look
                  for a blend of safety, sizeable income and modest capital
                  appreciation. The amount in these kinds of funds should...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Balanced Mutual Fund
                <p>
                  A mutual fund that invests in and generates its return from a
                  combination of equity and debt assets is known as a balanced
                  mutual fund. It is geared primarily towards...
                </p>
              </h4></a
            ><a 
              ><h4>
                Basing
                <p>
                  It is the period when a stock shows minimum downward or upward
                  movement. In other words, the stock trades in sideways, which
                  forms signature patterns like cup with a handle....
                </p>
              </h4></a
            ><a 
              ><h4>
                Basis
                <p>
                  Basis refers to the difference between the futures price and
                  the current cash price of the same commodity. Points to
                  remember: In case of a futures market, basis is the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Basis of Allotment
                <p>
                  Allotment is the process of allocating shares to shareholders,
                  based on prior agreements, most commonly seen in an IPO. This
                  allotment of shares is based on conditions that must be...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Best Efforts Underwriting
                <p>
                  In Best Efforts Underwriting, the underwriters try their best
                  to sell all the securities, but they are in no way obligated
                  to purchase them. Points to remember: If demand from...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Beta (Coefficient)
                <p>
                  Any market risk associated with any kind of security is
                  measured in terms of Beta. Also known as beta coefficient, it
                  is the ratio of historical returns of an individual...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Block Trade
                <p>
                  Block trade, as the name suggests, is an exchange of a fixed
                  number of securities at an agreed price between two parties.
                  The number of securities to be traded is...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Bluechip Fund
                <p>
                  A mutual fund that invests in blue chip stocks (a large
                  established company with a proven track record of returns), is
                  called as Bluechip fund. Points to Remember: Bluechip
                  stocks...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Board of Trade Clearing Corporation
                <p>
                  Also known as Clearing Corporation, the Board of Trade
                  Clearing Corporation acts as a guarantor for all the trades
                  cleared and settles all the trades made at the Chicago
                  Board...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Book Building
                <p>
                  Book building is a price discovery method in which the company
                  issuing the shares doesn’t fix a specified price of the shares
                  issued. Instead, it provides an indicative price range...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Book-Entry Securities
                <p>
                  The electronically recorded securities that contain the
                  creditor’s name, tax identification number and the amount are
                  called book-entry securities. Points to remember: No paper
                  certificates are issued for the proof...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Book Running Lead Manager (BRLM)
                <p>
                  Book Running Lead Manager (BRLM) plays an important role in
                  the complete procedure of an Initial Public Offering (IPO). It
                  is necessary to appoint a solid BRLM for a successful...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Book to Bill Ratio
                <p>
                  Within a certain time period, the book to bill ratio is the
                  ratio of new orders of the company to the shipments. It is
                  widely used in semiconductor industry. Points...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Booked Orders
                <p>
                  Orders that do not trade upon entry immediately are known as
                  booked orders. Points to remember: They are also known as
                  outstanding orders.
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Bottom Line
                <p>
                  A company’s net after-tax profits are known as the bottom
                  line. It gets its interesting name for the simple reason that
                  it is mentioned at the bottom of the income...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Bought Out Deal
                <p>
                  A bought out deal is a process in which a company offers
                  securities or shares to the public, through a sponsor. The
                  sponsor can be a bank, any financial institution...
                </p>
              </h4></a
            ><a 
              ><h4>
                Bounce
                <p>
                  When a stock hits support (a price on the chart where it faces
                  resistance to further dips) and then moves up sharply, the
                  phenomenon is known as ‘Bounce’. It may...
                </p>
              </h4></a
            ><a 
              ><h4>
                Box Spread
                <p>
                  When an investor locks an arbitrage profitable position that
                  involves no risk, then it is known as box spread. Points to
                  remember: It provides minimum amount of risk. A box...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Bracket order
                <p>
                  A bracket order is a way in which a trader can limit her/his
                  loss. A trader can "bracket" an order and set two orders on
                  the opposite ends i.e. she/he...
                </p>
              </h4></a
            ><a 
              ><h4>
                Broker
                <p>
                  A broker is a person/organization who helps people purchases
                  and sells goods and/or assets.
                </p>
              </h4></a
            ><a 
              ><h4>
                Brokerage
                <p>
                  Brokerage is the amount that a broker charges for purchasing
                  and selling goods and assets for others.
                </p>
              </h4></a
            ><a 
              ><h4>
                BSE
                <p>
                  The Bombay Stock Exchange was started in 1875. It was called
                  the "Native Share and Stock Brokers' Association" back then.
                  It has about 6,000 companies and has developed India's
                  capital...
                </p>
              </h4></a
            ><a 
              ><h4>
                Bullion
                <p>
                  Bullion is a common word for gold and silver, the jewels being
                  99.5% pure and in the form of bars or ingots. To create
                  bullion, gold should be first extracted...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Bureau of Indian Standards (BIS)
                <p>
                  The Bureau of Indian Standards acts as hallmarking agency that
                  certifies gold on the basis of Indian standards. Gold is
                  tested and assessed at BIS centres and then certified as...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Butterfly Spread
                <p>
                  A butterfly spread combines bull and bear spreads in order to
                  form a neutral options strategy. Points to remember: A
                  butterfly spread makes use of four options contracts that
                  have...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Buy and Hold
                <p>
                  When a stock or security is acquired for long term regardless
                  of market fluctuations, the act is known as ‘Buy and Hold’.
                  Points to remember: Such investors are not concerned...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Buying forward
                <p>
                  Buying forward is the purchase of commodities or securities at
                  a specified price for delivery at a future date. When the
                  price of the security or demand of a currency...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="C">
            <a 
              ><h4>
                Call Option
                <p>
                  An option that gives the buyer the right to, but not the
                  obligation to, buy underlying futures contracts at the strike
                  price before the expiry is called a Call Option....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cancellation
                <p>
                  The company issuing shares can cancel the offering for another
                  form of financing, when an IPO process faces difficulties in
                  getting investors to raise the required capital for it.
                  Points...
                </p>
              </h4></a
            ><a 
              ><h4>
                Capital
                <p>
                  To an economist, capital refers to machinery, inventory and
                  factories required to produce products. But, for an investor,
                  capital can refer to their handheld cash and the financial
                  assets which...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Capital Gain or Loss
                <p>
                  The profit or loss that results through the sale of certain
                  assets is classified as a capital gain or loss. It encompasses
                  stocks and other investments - like investment property....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Capital Growth
                <p>
                  A rise in the market value of a mutual fund’s securities is
                  known as the capital growth of the mutual fund. This is
                  reflected in its net asset value (NAV)...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Capped Style Option
                <p>
                  An option which has an established profit cap is known as a
                  capped style option. These are also known as Protected
                  Options. Points to remember: A capped style option protects...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Carrying Charge
                <p>
                  Also known as the cost of carrying, it is the cost of storing
                  a physical commodity over a definite period of time. These
                  include insurance, storage costs and interest charges...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cash Commodity
                <p>
                  Cash commodity is an actual commodity - like soybean, corn,
                  silver which is bought or sold by a person, in contrast to
                  digital commodities like shares. Points to remember: In...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cash Contract
                <p>
                  A cash contract is an agreement for immediate or future
                  delivery of the commodity. Points to remember: A cash contract
                  has a direct connection between the seller and the buyer....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cash Market
                <p>
                  Cash Market is a public marketplace where transactions of
                  financial instruments such as securities or commodities are
                  immediately settled. Cash Market is the opposite of a futures
                  market wherein the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Charting
                <p>
                  Market variables such as stock prices, market averages,
                  commodity prices, trading volume, interest rates etc. are
                  mathematically plotted on a graph in order to spot trends and
                  also predict future...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cheapest to deliver
                <p>
                  Cheapest to deliver is a method used to determine the cash
                  debt instrument that will produce the maximum profit against a
                  futures contract. Points to remember: It is important for...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Circuit Breaker
                <p>
                  A Circuit Breaker or a collar is a measure that is set in
                  order to stop panic selling after either a security or an
                  index has fallen drastically by a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Clearinghouse
                <p>
                  A clearinghouse is an agency responsible for reporting the
                  trading data, settling trading accounts, regulating delivery
                  and clearing trades. Points to remember: A clearinghouse is a
                  third party, in all...
                </p>
              </h4></a
            ><a 
              ><h4>
                Co Manager
                <p>
                  A co-manager is an underwriter in a stock offering, but not a
                  part of the Lead Manager. They deal with a particular niche of
                  investors in an IPO process and...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Commodity
                <p>
                  Raw materials and bulk goods such as metals, livestock, oil,
                  grains, cotton, cocoa, sugar etc which are used to manufacture
                  consumer products that can be easily used by the average...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Commodity Actuals
                <p>
                  Commodity Actuals are a physical commodity that highlight a
                  futures contract or traded in the physical market. Points to
                  remember: It is traded in a physical market or the futures...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Commodity Exchange
                <p>
                  Commodity exchange is a legal body that regulates and imposes
                  rules and procedures for the trading standardized commodity
                  contracts and related investment products. It also refers to
                  the physical centre...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Commodity spread/straddles
                <p>
                  The commodity-product spread is the difference between the
                  price of a raw material commodity and price of a finished
                  product created from that commodity. A common
                  commodity-product spread is the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Commodity Trading Adviser
                <p>
                  A commodity trading advisor is a firm or an individual that
                  advises others on buying and selling of the options and some
                  foreign exchange contracts. Points to remember: The role...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Contract note
                <p>
                  It is the official legal record of a transaction that is
                  carried out on a stock exchange through a stock broker. The
                  trader gets the contract note at the end...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Cover order
                <p>
                  In a marketplace, an order placed with a Stop Loss Order is
                  called as Cover Order. In a cover order both the buy/sell
                  orders are placed with a mandatory Stop...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Currency trading
                <p>
                  Trading in international currencies is a global market where
                  about $1.9 trillion is circulated in a day. It is one of the
                  largest financial markets in the whole world. MNCs,...
                </p>
              </h4></a
            ><a 
              ><h4>
                Custodian
                <p>
                  A bank or company that holds the mutual funds’ assets in order
                  to reduce risk is known as a custodian. Points to remember: A
                  custodian holds the securities in either...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="D">
            <a 
              ><h4>
                Debentures
                <p>
                  A debenture is a debt instrument which is an insecure
                  instrument i.e. it is not backed by a physical assets or
                  collateral. Debentures are secure only because of the
                  issuer's...
                </p>
              </h4></a
            ><a 
              ><h4>
                Debt Fund
                <p>
                  A debt fund is a type of mutual fund wherein the invested
                  amount is distributed across securities that are likely to
                  yield you a fixed income. Points to Remember: Debt...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Delivery date
                <p>
                  The day in the month that commodities on a futures contract
                  have to be delivered is called the Delivery date. Every
                  forward and futures contract contains a delivery date on...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Delivery Notice
                <p>
                  It is a notice of a clearing member’s intention to deliver a
                  stated quantity of a commodity in settlement of a short
                  futures option. The holder in a futures contract...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Delivery Points
                <p>
                  Delivery points are the locations where the commodities will
                  be delivered to the buyer. It can be a warehouse where
                  commodities are stored or an exchange facilitated delivery
                  point. Points...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Delivery trading
                <p>
                  Delivery is the final step of finalization of a purchase or
                  sale of a financial investment instrument. Just like the
                  purchase and sale of any other product in a marketplace,...
                </p>
              </h4></a
            ><a 
              ><h4>
                Demat
                <p>
                  Demat is short for "dematerialization" (DEMAT). It is the move
                  from physical certificates to an electronic version of keeping
                  a record of all the shares an investor owns. With the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Depository participant
                <p>
                  A Depository Participant is an agent or representative of a
                  depository. A depository can be literally translated as a
                  place where valuables are stored for safety purposes. However,
                  in the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Derivative
                <p>
                  A derivative is not a stand-alone financial product. Its value
                  is dependent or it derives its value from another variable
                  asset.
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Derivatives Market
                <p>
                  Derivatives market is the financial market for derivatives
                  which are a group of products including futures and options
                  whose value is derived from and/or is dependent on the value
                  of...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Derivatives Trading
                <p>
                  Derivatives are those instruments that are dependent on
                  another security for its value. There are several underlying
                  assets based on which traders can purchase and sell in the
                  derivatives market....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Differential Pricing
                <p>
                  When a specific category is offered shares at a price
                  different than the other categories, the act is called as
                  differential pricing. According to the DIP (Disclosure and
                  Investor Protection)...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Direct Public Offerings
                <p>
                  When securities are offered direct to the public, without any
                  aid from an investment banking firm, the company is said to be
                  doing a Direct Public Offering (DPO). The companies...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Discount brokers
                <p>
                  Discount brokers are those brokerage firms who charge a
                  reduced fee/commission for helping investors purchase and sell
                  on the stock markets. Such discount brokers like Upstox
                  utilize the best of...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Dividend Plan
                <p>
                  The earnings from a mutual fund are available in different
                  ways. One of them is a dividend plan. In a dividend plan, the
                  investor receives a fixed dividend (or payout...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Dividend Stripping
                <p>
                  Dividend stripping is when the investment is made with the
                  thought of exiting the fund as soon as the dividend is
                  received. Dividend stripping is usually a strategy used by...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Draft Offer Document
                <p>
                  As the name suggests, it is the draft of the offer document
                  for an IPO (Initial Public Offering). It is the first ever
                  document submitted by the company to SEBI...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="E">
            <a
              
              class="post-link"
              ><h4>
                Equilibrium Price
                <p>
                  Equilibrium is the state when the supply and demand of the
                  market balance one another. As a result, prices remain stable.
                  The equilibrium price is the market price where the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Equity
                <p>
                  When speaking of the financial markets, equity is a stock or
                  any other security that is owned by a person. Equity is the
                  share of the stakeholder in a company's...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Equity Options
                <p>
                  The options on shares which belong to an individual’s common
                  stock are said to be equity options. These options are known
                  to be the most common type of equity derivative....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Equity Trading
                <p>
                  Equity Trading is the purchasing and selling of company stock
                  shares. In publicly traded companies or IPOs, shares are
                  bought and sold through stock exchanges such as the BSE or...
                </p>
              </h4></a
            ><a 
              ><h4>
                Exit Load
                <p>
                  Whenever an investor makes an exit from a mutual fund within a
                  duration as set by the mutual fund scheme, they may need to
                  pay a charge known as the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                External Risk Factors
                <p>
                  The external factors that affect the share performance of the
                  company, (which need to be mentioned in the offer document
                  when going public), are called external risk factors. These
                  factors...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="F">
            <a 
              ><h4>
                Filing
                <p>
                  It is the copy of a prospectus with the documents which is
                  submitted to the Registrar of Companies (ROC). Points to
                  remember: Filing is a mandatory step which needs to...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Firm Allotment
                <p>
                  A part of the total money the company raises in the market is
                  fixed for the promoters to avoid dilution of their stakes.
                  This is termed as Firm Allotment. Points...
                </p>
              </h4></a
            ><a 
              ><h4>
                Flipping
                <p>
                  The process of buying the IPO at the offering price and
                  selling it off as soon as trading starts in the open market is
                  termed as flipping. It is a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Follow on Public Offering (FPO)
                <p>
                  If an already listed company issues fresh securities to the
                  public or makes an offer for sale, then it is known as Follow
                  on Public Offering (FPO). In such a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Forward Price
                <p>
                  The fixed price at which a specified amount of a commodity is
                  to be delivered on a fixed date in the future. The price is
                  fixed by the long buyer...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Forwards Market Commission (FMC)
                <p>
                  Forward Market Commission is the Regulatory Authority in India
                  for commodity futures trading. FMC is headquartered in Mumbai.
                  Just like SEBI regulates Stock market, FMC regulates
                  commodities futures market. They...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Full Membership (CBOT)
                <p>
                  A CBOT full membership is the membership of Chicago Board of
                  Trading that provides the individuals with the right to trade
                  in all the futures and options listed under it....
                </p>
              </h4></a
            ><a 
              ><h4>
                FUTEXAGRI
                <p>
                  Futexagri is an equal- weighted index of commodities traded on
                  NCDEX based in the price of near month future contract.
                  Weighted index is found out by assigning weights to the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Futures
                <p>
                  Futures are contracts for assets such as commodities or shares
                  bought at predetermined prices. However, the final delivery
                  and actual payment for futures contracts is done later. That's
                  why in...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Futures Commission Merchant
                <p>
                  A person or firm involved in accepting and handling the buying
                  and selling of futures contracts is known as futures
                  commission merchant. Points to remember: A futures commission
                  merchant is...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Futures Contract
                <p>
                  A futures contract is a legal agreement based on future
                  exchanges, that is, buying and selling of a financial
                  instrument in both equity and commodity at a fixed price in...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Futures Exchange
                <p>
                  A Futures exchange refers to the market place where the
                  exchange of futures contracts, futures and options, and other
                  such future trading takes place. Points to remember: The
                  exchange allows...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Futures trading
                <p>
                  People can trade in the futures exchange or futures market
                  where people can trade futures contracts which are contracts
                  to purchase a certain volume of a particular commodity or
                  securities...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="G">
            <a 
              ><h4>
                Gamma
                <p>
                  Gamma is the rate of change of delta of an option, in response
                  to changes in the prices of an underlying asset. It gives us a
                  significant evaluation of convexity...
                </p>
              </h4></a
            ><a 
              ><h4>
                Gilt Fund
                <p>
                  Gilt funds are a kind of security with minimal risk involved
                  and are issued by India’s central government. Gilt funds
                  originated from the British investment model. In most cases,
                  they...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                GIM Membership (CBOT)
                <p>
                  GIM stands for Government Instrument Market. The CBOT, or the
                  Chicago Board of Trade, provides for a membership to
                  merchants. Points to remember: The GIM membership provides
                  merchants with the...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Global Fund
                <p>
                  Global funds are a kind of mutual fund which invest in stocks
                  throughout the world. Being a global fund, it filters the most
                  apt and best investment plans from a...
                </p>
              </h4></a
            ><a 
              ><h4>
                GLOBEX
                <p>
                  GLOBEX® is a global after-hours electronic trading system. It
                  provides a platform for derivatives, futures and commodity
                  contracts. Points to remember: Globex operates at all times
                  and is not constrained...
                </p>
              </h4></a
            ><a 
              ><h4>
                Go Public
                <p>
                  When a privately held company offers shares to the public for
                  the first time through Initial Public Offering (IPO), the act
                  of becoming an IPO is called ‘going public.' Points...
                </p>
              </h4></a
            ><a 
              ><h4>
                Green Shoe
                <p>
                  Technically known as an over-allotment option, a green shoe is
                  a part of underwriting agreement, through which the issuer can
                  distribute additional shares. The additional amount is
                  typically 15%. The...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Gross Domestic Product (GDP)
                <p>
                  Gross domestic product is the best way to measure a country's
                  economy. GDP is the total value of everything produced by all
                  the people and companies in the country. GDP...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Gross National Product (GNP)
                <p>
                  Gross national product (GNP) is a reckoned figure of total
                  value of all the final products and services transpired over a
                  given period, by the means of production owned by...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Growth Plan
                <p>
                  A growth plan is a variant of mutual fund schemes. As the name
                  suggests, it is a kind of mutual fund with the objective of
                  long term capital growth. The...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="H">
            <a
              
              class="post-link"
              ><h4>
                Hard Underwriting
                <p>
                  When an underwriter buys his/her commitment at the earliest
                  stage, then it is known as hard underwriting. Points to
                  remember: If the shares are not bought by investors then
                  the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Hedge Fund
                <p>
                  A hedge fund is a kind of fund that pools the capital of
                  investors and then invests them in a variety of schemes.
                  Retail investors cannot invest in hedge funds....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Holding Company
                <p>
                  A Holding Company is the company that has the voting control
                  over another company, because it owns the necessary amount of
                  shares of that particular company. Points to remember: A...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Holding Period
                <p>
                  The time for which an investor holds on to a security is known
                  as the holding period. The period during which an investment
                  is attributable to a particular investor is...
                </p>
              </h4></a
            ><a 
              ><h4>
                Holdings
                <p>
                  An investor might have a vast portfolio--the contents of which
                  are known as holdings. All securities are typically ranked
                  according to the ratio of the portfolio they occupy. This
                  arrangement...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="I">
            <a 
              ><h4>
                ICAR
                <p>
                  Indian Council for Agricultural Research, is an autonomous
                  body that coordinates agricultural education and research in
                  India. It is the hub of agricultural research institutes in
                  the world, presided over...
                </p>
              </h4></a
            ><a 
              ><h4>
                IFFCO
                <p>
                  Indian Farmers Fertiliser Cooperative Limited is a large scale
                  fertiliser cooperative federation based in India. The IFFCO is
                  responsible for the production and sale of tonnes of
                  fertiliser material, every...
                </p>
              </h4></a
            ><a 
              ><h4>
                Indices
                <p>
                  The performance of the stock market can be estimated by taking
                  into account the performance of stocks, bonds and other
                  financial instruments contained within the marketplace. These
                  statistical tools that...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Initial Public Offer (IPO) Aftermarket
                <p>
                  When a private company stock is offered to the public for the
                  first time, the offer is said to be an Initial Public offering
                  (IPO). Initial Public Offers are usually...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Intraday Trading
                <p>
                  Intraday Trading is the system of trading where one has to
                  square-off the trade within the same day i.e. a trader has to
                  buy and sell or sell and buy...
                </p>
              </h4></a
            ><a 
              ><h4>
                ISIN
                <p>
                  International Securities Identification Numbering (ISIN)
                  system, uniquely identifies a security. The ISIN is an
                  international standard formed by the International
                  Organization for Standardization (ISO), for the purpose of
                  numbering specific...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Issue Price
                <p>
                  The price at which new security is issued and is to be
                  distributed among a set of people prior to the new issue
                  trading is called the Issue Price. Points...
                </p>
              </h4></a
            ><a 
              ><h4>
                Issuer
                <p>
                  The entity that issues or distributes securities is known as
                  the Issuer. The issuer could be anyone, a company, government
                  or municipality. The issuers are legally responsible for all
                  kinds...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="J">
            <a
              
              class="post-link"
              ><h4>
                Joint Applications
                <p>
                  An application can be filled in two ways: as a single entity
                  or joint parties. The applications registered under the joint
                  names consists of names--more than one. The payments made...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="L">
            <a
              
              class="post-link"
              ><h4>
                Lead Underwriter
                <p>
                  A Lead Underwriter is in charge of organizing the distribution
                  of member participation shares, syndicate and making
                  stabilized transactions. The name of the lead underwriter is
                  mentioned on the left...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Limit order
                <p>
                  A limit order is an order where the trader defines the price
                  at which the order should be executed. The opposite of a limit
                  order is a market order.
                </p>
              </h4></a
            ><a 
              ><h4>
                Listing
                <p>
                  Listing majorly indicates the shares of a company that is on
                  the stock list. It should be a company that has officially
                  been traded on a stock exchange. On a...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Listing Date
                <p>
                  The date when a newly recorded security is up for sale is
                  called the effective sale. In other words, it the date on
                  which the shares will be traded for...
                </p>
              </h4></a
            ><a 
              ><h4>
                Lock-In
                <p>
                  In case of IPOs, the lock-in period refers to the duration
                  wherein those with prior information about the impending IPO
                  or the offer document are not allowed to bid or...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="M">
            <a
              
              class="post-link"
              ><h4>
                Market order
                <p>
                  A market order is an order where the trade will be executed at
                  the current prevailing market price. The opposite of a market
                  order is a limit order.
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Minimum Subscription
                <p>
                  Minimum subscription refers to the minimum number of shares
                  that a company needs to get out of the entire issue by the
                  date of closure. Currently, every company is required...
                </p>
              </h4></a
            ><a 
              ><h4>
                MSCCGMF
                <p>
                  Maharashtra State Co-operative Cotton Growers Marketing
                  Federation is one of the world’s largest suppliers of cotton.
                  It produces over 3.5 million bales of cotton, and has exports
                  exceeding USD 400...
                </p>
              </h4></a
            ><a 
              ><h4>
                MSP
                <p>
                  Minimum Support Prices (MSP), is an initiative of the
                  Government of India to protect producers against any steep
                  fall in prices of agricultural products. The minimum support
                  prices are announced...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Mutual Funds Distributor
                <p>
                  Any firm or an individual who facilitates buying and selling
                  of units within a mutual fund between an AMC (Asset Management
                  Company) and interested investors, is categorised as a
                  mutual...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="N">
            <a 
              ><h4>
                NABARD
                <p>
                  National Bank for Agriculture and Rural Development (NABARD)
                  in India is a financial institution which deals with matters
                  pertaining to policy, planning and operations in the fields of
                  agriculture and...
                </p>
              </h4></a
            ><a 
              ><h4>
                NAFED
                <p>
                  National Agricultural Cooperative Marketing Federation of
                  India limited was established with the aim of promoting
                  cooperative marketing of agricultural produce, for the benefit
                  of farmers. Further objectives include organising,
                  processing...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                National Securities Depository Limited (NSDL)
                <p>
                  National Securities Depository Limited is an Indian central
                  securities depository, based in Mumbai. It was the first
                  electronic securities depository in India that was established
                  on November 8, 1996. NSDL...
                </p>
              </h4></a
            ><a 
              ><h4>
                NBOT
                <p>
                  National Board of Trade; an Indore based national
                  multi-commodity exchange. Being a major futures market for
                  edible oils, NBOT is making attempts to become a national
                  commodity exchange; thereafter qualifying...
                </p>
              </h4></a
            ><a 
              ><h4>
                NCDEX
                <p>
                  National Commodity and Derivatives Exchange of India (NCDEX)
                  is a demutualised online commodity exchange that is promoted
                  by various bodies such as ICICI Bank, Canara Bank, NABARD,
                  IFFCO, CRISIL, and...
                </p>
              </h4></a
            ><a 
              ><h4>
                Net Offer
                <p>
                  The capital that is issued after allotting it to the
                  promoters, which would majorly be raised from the public is
                  known as Net offer.
                </p>
              </h4></a
            ><a 
              ><h4>
                New Issue
                <p>
                  New Issue refers to a security that is issued, registered, and
                  sold in a market for the first time. It doesn’t necessarily
                  refer to the newly issued stocks, although the...
                </p>
              </h4></a
            ><a 
              ><h4>
                Nifty
                <p>
                  The S&amp;P CNX Nifty or what is also commonly known as NSE
                  Nifty or Nifty fifty is an Indian stock index. This is
                  basically an average of 50 indian stocks....
                </p>
              </h4></a
            ><a 
              ><h4>
                NSE
                <p>
                  NSE is the abbriviation for the National Stock exchange of
                  India. The NSE is a leading stock exchange in India
                  established in 1952 located in Mumbai.
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="O">
            <a
              
              class="post-link"
              ><h4>
                Ask or Offer
                <p>
                  It is the act of putting up securities for sale (or offering)
                  by a seller. It is accompanied by an Ask Price. Points to
                  remember: The basis of the stock...
                </p>
              </h4></a
            ><a 
              ><h4>
                Offer Date
                <p>
                  The date on which the securities are first made available to
                  the public is known as the offer date. Points to remember: The
                  offer date is decided under the underwriting...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Offer Document
                <p>
                  The prospectus that consists information regarding the public
                  issue or offer for sale and in case of a rights issue, it is
                  the letter of offer, which is filed with...
                </p>
              </h4></a
            ><a 
              ><h4>
                Options
                <p>
                  Options are versatile securities which are financial
                  derivatives. Options are a contract between the one who holds
                  the security and the one who writes up the contract. It is
                  a...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="S">
            <a
              
              class="post-link"
              ><h4>
                Share Market
                <p>
                  A share market is a marketplace where shares of publicly
                  listed companies are issued and traded through stock exchanges
                  or in over-the-counter markets.
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="T">
            <a 
              ><h4>
                Top gainers
                <p>
                  A security that gains price or increases in price during the
                  course of a single trading day is called a gainer. A gainer is
                  a security that has a higher...
                </p>
              </h4></a
            ><a 
              ><h4>
                Top losers
                <p>
                  A security that loses value during the course of a single
                  trading day is called a loser. A loser is a secutiry with a
                  high price at the open or...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Trading Account
                <p>
                  Just like a traditional bank account holds your salary and
                  savings, a trading account holds cash and securities that is
                  usually held at a financial institute such as a broker....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Trading indicators
                <p>
                  Trading indicators or Market Indicators are a group of
                  technical indicators that traders use in order to predict the
                  direction that financial indexes might take. Most technical
                  analysis indicators are...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Trading platforms
                <p>
                  A trading platform in terms of finance is a computer software
                  through which you as an investor or a trader can open, close
                  and manage your positions in the market....
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Trading Strategies
                <p>
                  A trading strategy is a plan that is put into action in order
                  to get profits by either trading in the direction of the
                  market or against the market. Trading...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Traditional Broker
                <p>
                  A brokerage firm or a traditional broker is an institute which
                  enables the purchasing and selling of securities in the
                  financial marketplace between a buyer and seller. A
                  traditional broker...
                </p>
              </h4></a
            ><a
              
              class="post-link"
              ><h4>
                Transfer of Shares
                <p>
                  Transfer of shares is when the title of a share is transferred
                  from one person to another. The company whose shares are being
                  transferred from one person to another should...
                </p>
              </h4></a
            >
          </div>
          <div class="post-info" id="W">
            <a
              
              class="post-link"
              ><h4>
                Wealth Management
                <p>
                  Wealth management is the practice of using personal investment
                  ideas, professional financial advise and accounting and tax
                  services, retirement planning and asset planning in order to
                  build up one's net...
                </p>
              </h4></a
            >
          </div>
        </div>
      </div>
    </section>

    <section class="subscribe-cta">
      <div class="content">
        <h2>Want More?</h2>
        <p>
          Drop in your email address here to get automatic updates whenever a
          new post is published.
        </p>
        <!-- <a href="#" class="button">Subscribe</a> -->

        <div class="blog-subscribe-cta" id="mc_embed_signup">
          <form
            action="../../../app/themes/upstox/subscribe.php"
            method="POST"
            accept-charset="utf-8"
            name="signup-form-footer"
            id="signup-form-footer"
          >
            <div class="subscribe-wrap-blue">
              <input
                type="text"
                name="email"
                placeholder="Enter email id here"
                autocomplete="off"
              />
              <a
                type="submit"
                value="SUBSCRIBE"
                id="submit-btn-footer"
                class="button subscribebtn-blue"
                target="_blank"
                >SUBSCRIBE</a
              >
              <div class="clearfix"></div>
              <p id="status-footer"></p>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
h4{
  color: rgb(51, 51 , 51) !important;
}
</style>
